<template>
  <v-card class="mx-auto" max-width="400" color="error">
    <v-card-title class="text-h1 justify-center">404</v-card-title>
    <v-card-title class="text-h3 justify-center">Page not found</v-card-title>
  </v-card>
</template>


<script>
export default {
  name: 'NotFoundComponent'
}
</script>